/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Layer } from "ol/layer";
import LayerGroup from "ol/layer/Group";
import { Accesses } from "~/utils/hooks/useAccess";
import { LayerDefaults, LayerGroupTitle, LayerTitle } from "../types/layers";

interface CreateLayerGroupInputs {
  includedLayers?: LayerTitle[];
  layers: Layer[];
  title: LayerGroupTitle;
  accesses: Accesses;
}

export const createLayerGroup = ({
  includedLayers,
  layers,
  title,
  accesses,
}: CreateLayerGroupInputs): LayerGroup | null => {
  const groupLayers = includedLayers
    ? layers.filter((l) => includedLayers.includes(l.get("title")))
    : layers;
  groupLayers.forEach((l) => {
    l.set("groupTitle", title);
    if (includedLayers && includedLayers.includes(l.get("title"))) {
      l.setVisible(true);
    }
  });

  // Access checking, return null if 0 layers remain
  const accessLayers = groupLayers.filter((l) => {
    const key = l.get("title") as LayerTitle;
    if (!LayerDefaults[key]) return false;
    if (LayerDefaults[key].requiredAccess === undefined) return true;
    return accesses[LayerDefaults[key].requiredAccess!];
  });
  if (accessLayers.length === 0) return null;
  const layerGroup = new LayerGroup({
    layers: accessLayers,
  });
  layerGroup.set("title", title);
  return layerGroup;
};
